import { PropertyTool, PropertyType } from '@/backend/types'
import type { ReviewStatus } from '@/modules/Project/Fields/types'
import { IconName } from '@/uiKit/IconName'
import type { AllFilterableType } from './Filters/types'

export const TOOL_ICON: Record<PropertyTool, IconName> = {
  [PropertyTool.aws_ocr]: 'ocr',
  [PropertyTool.bing_search]: 'bing-logo',
  [PropertyTool.claude_3_5_haiku_vertex_ai]: 'company-anthropic',
  [PropertyTool.claude_3_5_haiku]: 'company-anthropic',
  [PropertyTool.claude_3_5_sonnet_vertex_ai]: 'company-anthropic',
  [PropertyTool.claude_3_5_sonnet]: 'company-anthropic',
  [PropertyTool.claude_3_7_sonnet_vertex_ai]: 'company-anthropic',
  [PropertyTool.claude_3_7_sonnet]: 'company-anthropic',
  [PropertyTool.claude_3_7_thinking_vertex_ai]: 'company-anthropic',
  [PropertyTool.claude_3_7_thinking]: 'company-anthropic',
  [PropertyTool.claude_3_haiku_vertex_ai]: 'company-anthropic',
  [PropertyTool.claude_3_haiku]: 'company-anthropic',
  [PropertyTool.claude_3_opus_vertex_ai]: 'company-anthropic',
  [PropertyTool.claude_3_opus]: 'company-anthropic',
  [PropertyTool.claude_3_sonnet_vertex_ai]: 'company-anthropic',
  [PropertyTool.claude_3_sonnet]: 'company-anthropic',
  [PropertyTool.claude_4_opus]: 'company-anthropic',
  [PropertyTool.claude_4_sonnet]: 'company-anthropic',
  [PropertyTool.claude_4_sonnet_vertex_ai]: 'company-anthropic',
  [PropertyTool.claude_4_opus_vertex_ai]: 'company-anthropic',
  [PropertyTool.code]: 'python-language',
  [PropertyTool.dall_e_3]: 'company-openai',
  [PropertyTool.gemini_1_5_flash]: 'company-google',
  [PropertyTool.gemini_1_5_pro]: 'company-google',
  [PropertyTool.gemini_2_0_flash_lite]: 'company-google',
  [PropertyTool.gemini_2_0_flash]: 'company-google',
  [PropertyTool.gemini_2_5_flash]: 'company-google',
  [PropertyTool.gemini_2_5_pro]: 'company-google',
  [PropertyTool.gemini_pro_vision]: 'company-google',
  [PropertyTool.gemini_2_5_flash_lite]: 'company-google',
  [PropertyTool.gemini_2_5_flash_lite_genai]: 'company-google',
  [PropertyTool.gemini_pro]: 'company-google',
  [PropertyTool.go]: 'company-v7',
  [PropertyTool.gpt_3_5_azure]: 'company-openai',
  [PropertyTool.gpt_3_5]: 'company-openai',
  [PropertyTool.gpt_4]: 'company-openai',
  [PropertyTool.gpt_4_1]: 'company-openai',
  [PropertyTool.gpt_4_1_mini]: 'company-openai',
  [PropertyTool.gpt_4_1_nano]: 'company-openai',
  [PropertyTool.gpt_4o_azure]: 'company-openai',
  [PropertyTool.gpt_4o_mini]: 'company-openai',
  [PropertyTool.gpt_4o]: 'company-openai',
  [PropertyTool.o3]: 'company-openai',
  [PropertyTool.o4_mini]: 'company-openai',
  [PropertyTool.http]: 'api-connection',
  [PropertyTool.imagen]: 'company-google',
  [PropertyTool.manual]: 'human-task',
  [PropertyTool.o1_mini]: 'company-openai',
  [PropertyTool.o1]: 'company-openai',
  [PropertyTool.o3_mini]: 'company-openai',
  [PropertyTool.ocr]: 'ocr',
  [PropertyTool.url_scrape]: 'link',
  [PropertyTool.web_search]: 'globe',
  [PropertyTool.whisper]: 'company-openai',
  [PropertyTool.gemini_2_0_flash_lite_genai]: 'company-google',
  [PropertyTool.gemini_2_5_pro_genai]: 'company-google',
  [PropertyTool.gpt_4_1_azure]: 'company-openai',
  [PropertyTool.gpt_4_1_mini_azure]: 'company-openai',
  [PropertyTool.gpt_4_1_nano_azure]: 'company-openai',
  [PropertyTool.gpt_4o_mini_azure]: 'company-openai',
  [PropertyTool.o4_mini_azure]: 'company-openai',
  [PropertyTool.gemini_2_5_flash_genai]: 'company-google',
  [PropertyTool.gemini_2_5_flash_thinking_genai]: 'company-google',
}

export const TYPE_ICON: Record<PropertyType, IconName> = {
  [PropertyType.text]: IconName.text,
  [PropertyType.file]: IconName.file,
  [PropertyType.file_collection]: IconName['multi-page-file'],
  [PropertyType.single_select]: IconName['single-select'],
  [PropertyType.multi_select]: IconName['multi-select'],
  [PropertyType.json]: IconName.json,
  [PropertyType.collection]: IconName.collection,
  [PropertyType.url]: IconName['link'],
  [PropertyType.user_select]: IconName['user'],
  [PropertyType.hub_select]: IconName['court'],
  [PropertyType.reference]: IconName['arrow-top-right'],
  [PropertyType.number]: IconName['number'],
  [PropertyType.data]: IconName['code-block'],
}

export const FILTERABLE_TYPE_ICON: Record<AllFilterableType, IconName> = {
  ...TYPE_ICON,
  status: IconName.status,
  review: IconName['human-task'],
}

export const REVIEW_ICON: Record<ReviewStatus, IconName> = {
  pending: 'pie-orange',
  approved: 'tick-green',
  rejected: 'cross-red',
}
